import React, { useContext } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { makeStyles } from '@material-ui/core/styles';
import { ActiveFormDataContext } from '../activeCaseForm/ActiveContext';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    margin: 'auto',
    width: '15%'
  },

}));

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});


const AnkleImage = () => {
  const [open, setOpen] = React.useState(false);
  const context = useContext(ActiveFormDataContext);
  const { setState, formData } = context;
  const classes = useStyles();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
    <div style={{paddingTop: '10px'}}>
    <Button className="mr-3" variant="contained" color="primary" onClick={handleClickOpen}
      style={{height: '6.5em', width: '.2em', fontSize: '1.6em', marginTop: '1.4em'}}
      ><span style={{writingMode: "vertical-rl", textOrientation: "upright"}}>Ankle</span></Button>
    </div>
    <div>
      <Dialog
        open={open}
        aria-labelledby="success-title"
        aria-describedby="success-description"
        fullWidth={true}
        maxWidth={'md'}
        style={{display: "block", paddingLeft:"17px"}}
        onClose={handleClose}
      >
        <DialogTitle className="text-center border-bottom" id="success-title" onClose={handleClose}>
        <span style={{ fontSize: '2.8em'}}>{"Ankle Center"}</span>
        <IconButton aria-label="close" onClick={handleClose} style={{float: "right"}}>
          <CloseIcon />
        </IconButton>
        </DialogTitle>
        <DialogContent>
          {formData.screen_shots && <img src={formData.screen_shots.ankle} width="60%" style={{maxHeight: "85vh"}} className="center-block"/> }
        </DialogContent>
      </Dialog>
    </div>
    </>
  );
}

export default AnkleImage;
